var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("header",[_c('p',{staticClass:"bold text-lg"},[(_vm.icon)?_c('b-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }